var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#243AB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19C26 18.4 26.4 18 27 18C27.6 18 28 18.4 28 19V27.1C28 28.7 26.8 30 25.3 30H14.7C13.2 30 12 28.7 12 27.1V12.9C12 11.3 13.2 10 14.7 10H19C19.6 10 20 10.4 20 11C20 11.6 19.6 12 19 12H14.7C14.3 12 14 12.4 14 12.9V27.1C14 27.6 14.3 28 14.7 28H25.3C25.7 28 26 27.6 26 27.1V19ZM21.8 10.1L27.8 16.1C28 16.3 28 16.6 27.8 16.8C27.7 16.9 27.6 16.9 27.5 16.9H22.9C21.8 16.9 21 16 21 15V10.4C21 10.1 21.2 9.89999 21.5 9.89999C21.6 9.99999 21.7 10.1 21.8 10.1ZM16 20H24C24.6 20 25 20.4 25 21C25 21.6 24.6 22 24 22H16C15.4 22 15 21.6 15 21C15 20.4 15.4 20 16 20ZM16 24H21C21.6 24 22 24.4 22 25C22 25.6 21.6 26 21 26H16C15.4 26 15 25.6 15 25C15 24.4 15.4 24 16 24Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocument);
export default __webpack_public_path__ + "static/media/ic-document.1fb1239e8cbba237c0e1c302f59038e7.svg";
export { ForwardRef as ReactComponent };